import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/Zalo.png'


const _withScopeId = n => (_pushScopeId("data-v-799006c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "app-sidebar"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sidebar-brand" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Zalo"
  }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h1", null, "TTYT Ngũ Hành Sơn"),
    /*#__PURE__*/_createElementVNode("p", null, "Hệ thống Zalo OA")
  ])
], -1))
const _hoisted_3 = { class: "sidebar-time" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-clock" }, null, -1))
const _hoisted_5 = { class: "sidebar-nav" }
const _hoisted_6 = { class: "sidebar-icon" }
const _hoisted_7 = { class: "sidebar-label" }
const _hoisted_8 = { class: "sidebar-footer" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "© Copyright 2024 - Trung tâm y tế khu vực Ngũ Hành Sơn", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Button = _resolveComponent("Button")!

  return ($props.isLoggedIn)
    ? (_openBlock(), _createElementBlock("aside", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("span", null, _toDisplayString($setup.currentTime.toLocaleTimeString("en-GB")) + " " + _toDisplayString($setup.currentTime.toLocaleDateString("en-GB")), 1)
        ]),
        _createElementVNode("nav", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menuItems, (item) => {
            return (_openBlock(), _createBlock(_component_RouterLink, {
              key: item.to,
              to: item.to,
              class: "sidebar-link"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_6, [
                  _createElementVNode("i", {
                    class: _normalizeClass(item.icon)
                  }, null, 2)
                ]),
                _createElementVNode("span", _hoisted_7, _toDisplayString(item.label), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Button, {
            label: "Đăng xuất",
            onClick: $setup.logout,
            icon: "pi pi-sign-out",
            iconPos: "right",
            class: "logout-button"
          }, null, 8, ["onClick"]),
          _hoisted_9
        ])
      ]))
    : _createCommentVNode("", true)
}